// Staff "Partner Brands" CREATE wizard — the ROUTE at /partners/brands/new,
// which the Partner Brands list page launches. It is chrome only: the page
// header, the launch context read off the query string, and what "cancel" and
// "finished" mean here. Everything else — the stepper, all five steps, the
// broker context fork — is PartnerBrandWizardBody, rendered identically by the
// in-record popup (PartnerBrandWizardModal). There is no second copy of a step.
// Gated by Permissions.Partners.ManageBrands (route-level in App.tsx).
//
// Launch context arrives ONLY as query params here (?ownerBrokerId=… etc.),
// because App.tsx renders this route with no props — the pre-owned launch from a
// record now opens the modal in place instead. The former initialOwner* props
// were removed: they were unreachable in production and only the test file ever
// supplied them, so keeping them would have left two context paths where the
// popup already owns the live one.

import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button, useDocumentTitle } from "@/design-system/components/ui";
import { PageHeader } from "@/components/layout/PageHeader";
import { PartnerBrandWizardBody } from "@/components/partners/partnerBrandForm/PartnerBrandWizardBody";

export function PartnerBrandCreateWizard() {
  useDocumentTitle("New partner brand");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (
    <div className="flex flex-col gap-space-4 p-space-4">
      <PageHeader
        eyebrow="Partners"
        title="New partner brand"
        subtitle="White-label skin for the public prequalification funnel."
        actions={
          <Button variant="tertiary" onClick={() => navigate("/partners/brands")}>
            <ArrowLeft className="w-4 h-4 mr-space-1" aria-hidden />
            Back to list
          </Button>
        }
      />

      <PartnerBrandWizardBody
        mode="create"
        ownerBrokerId={searchParams.get("ownerBrokerId")}
        ownerBrokerName={searchParams.get("ownerBrokerName")}
        ownerBrokerageId={searchParams.get("ownerBrokerageId")}
        ownerBrokerageName={searchParams.get("ownerBrokerageName")}
        onCancel={() => navigate("/partners/brands")}
        onCompleted={(brandId) =>
          navigate(brandId ? `/partners/brands/${brandId}` : "/partners/brands")
        }
      />
    </div>
  );
}
